module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"You have been signed out","message":"Thank you for using ECS Admin. If you would like to sign in again, please launch the application from your Clearlogin dashboard."},"es":{"title":"Ha sido desconectado","message":"Gracias por usar la aplicación de Administración ECS. Si desea iniciar sesión de nuevom por favor inicie la aplicacióon de su tablero Clearlogin."}}')
  delete Component.options._Ctor
}
